import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { saveEntity, deleteEntity } from '../../redux/solicitorsRefReducer';
import { showConfirm } from '../../redux/msgReducer';

import Button from '@material-ui/core/Button';

export default function SolicitorsRefDetailBottomButtons() {
    const dispatch = useDispatch();
    const history = useHistory();

    const { workingEntity } = useSelector(state => {
        return state.solicitorsRef;
    });

    const { id, idDuplicate } = useParams();

    const navClicked = (path) => {
        history.push(path);
    };

    const confirmDelete = () => {
        const fnConfirm = (_) => { dispatch(deleteEntity(history)); };
        dispatch(showConfirm("確定刪除？", fnConfirm));
    };

    return <div style={{ textAlign: 'center' }} className="mt-5">
        <Button variant="contained" className="mr-2" size="small" disableElevation onClick={() => { dispatch(saveEntity(history)); }}>儲存參考律師樓</Button>
        {!idDuplicate && <Button variant="contained" className="mr-2" size="small" disableElevation onClick={() => { history.replace(`/solicitorsRefDetail/0/${id}`); }}>另存參考律師樓</Button>}
        {workingEntity && !workingEntity.isNew() && <Button variant="contained" className="mr-2" size="small" disableElevation onClick={() => { confirmDelete(); }}>刪　除</Button>}
        <Button variant="contained" className="mr-2" size="small" disableElevation onClick={() => { navClicked("/solicitorsRef"); }}>返回列表</Button>
    </div>
}
